import { useEffect, useState } from "react";
import { RoomMemberInfo, RoomModerationInfoCollection } from "@lifeat/shared/data-models/Rooms/RoomModerationTypes";
import { useDatabaseContext } from "@contexts/DatabaseContext";

export default function useRoomMemberInfoListener(userId: string, roomId: string): RoomMemberInfo {
    const db = useDatabaseContext();

    const [roomMemberInfo, setRoomMemberInfo] = useState<RoomMemberInfo>();
    useEffect(() => {
        if (userId && roomId) {
            const node = RoomModerationInfoCollection.at(roomId)
                .at("allRoomMembersInfo")
                .at("roomMembers")
                .at(userId).node;
            const unsub = db.subscribe(node, "value", (data) => {
                if (data.success) {
                    setRoomMemberInfo(data.value);
                }
            });

            return () => unsub();
        }
        return undefined;
    }, [userId, roomId]);

    return roomMemberInfo;
}
